module.exports = __webpack_public_path__ + "static/media/integrated-self.c5c204c4.png";